import { FeatureFlags, useFeatureFlag } from '@/modules/featureFlags';

const useReceiptsFeatureFlag = () => {
  const isReceiptsEnabled = useFeatureFlag(FeatureFlags.RECEIPTS_FULL_FLOW);
  return { isReceiptsEnabled };
};

export default useReceiptsFeatureFlag;